import * as React from 'react';
import { UIText1, UIText2, useDeviceType } from '@cian/ui-kit';

import * as styles from './BanksList.css';

interface IBanksListProps {
  logos: string[];
  moreCount?: number;
}

export const BanksList: React.FC<IBanksListProps> = ({ logos, moreCount }) => {
  const hasMore = moreCount && moreCount > 0;

  const deviceType = useDeviceType();
  const UIText = deviceType === 'desktop' ? UIText1 : UIText2;

  return (
    <div className={styles['container']}>
      {logos.map(logo => (
        <img className={styles['logo']} src={logo} key={logo} alt="" />
      ))}
      {hasMore && (
        <span className={styles['counter']} data-testid="Counter">
          <UIText>+{moreCount}</UIText>
        </span>
      )}
    </div>
  );
};
